module.exports = __webpack_public_path__ + "img/buddy_mouth-06.faad5e14.svg";